module.exports = __webpack_public_path__ + "static/media/teamBannerThree.d5e29a48.png";